// ST-1258 -Claude- 404 page.
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, EmptyState } from '@nearrme/ui-web';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="max-w-2xl mx-auto px-4 py-16">
      <EmptyState
        title={t('errors.notFound')}
        description="The page you're looking for doesn't exist."
        action={
          <Link to="/">
            <Button variant="primary">← Back to home</Button>
          </Link>
        }
      />
    </div>
  );
}
